import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaLogs } from "@/components/agenda/agenda-logs";

export const Route = createFileRoute("/agenda/logs")({
  component: () => (
    <AgendaShell>
      <AgendaLogs />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Logs e lixeira — Agenda — GPS Drive" }] }),
});
